const apiUrl = process.env.REACT_APP_API_URL;
export const GetComandesGenerades = async ( page : string) => {
    try {
        const response = await fetch(`${apiUrl}:8072/comandesgenerades`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            }
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
